import Vue from 'vue';
import {
  VERIFY_VENDOR,
  CREATE_VENDOR_SESSION
} from './actions.type'
import ApiService from '@/common/api.services'

const state = {
  externalSite: JSON.parse(localStorage.getItem('externalSite')) || false
};

const getters = {
  isExternalSite: (state) => state.externalSite,
};

const actions = {
  updateExternalSite({ commit }, value) {
    commit('setExternalSite', value);
  },
  [VERIFY_VENDOR](context, params) {
    return ApiService.post('/vendor/verify', params)
        .then(response => {
            return response.data;
        })
        .catch(error => {
            return error;
        });
},


};

const mutations = {
  setExternalSite(state, value) {
    state.externalSite = value;
    localStorage.setItem('externalSite', JSON.stringify(value));
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
};